var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "stock-images-thumbnail-card",
    },
    [
      _c("Thumbnail", {
        staticStyle: {
          background: "var(--light-gray-color-40)",
        },
        attrs: {
          url: _vm.url,
          width: "200px",
          contain: "",
        },
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$gettext("Format")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "file-pic",
                      role: "presentation",
                      alt: "",
                    },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.format) +
                      "\n                    (" +
                      _vm._s(_vm.width) +
                      " × " +
                      _vm._s(_vm.height) +
                      ")\n                "
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.$gettext("Größe")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("studip-file-size", {
                    attrs: {
                      size: _vm.size,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.mkdate
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(_vm.$gettext("Erstellt")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("studip-date-time", {
                        attrs: {
                          timestamp: _vm.mkdate / 1000,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.chdate
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(_vm.$gettext("Geändert")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("studip-date-time", {
                        attrs: {
                          timestamp: _vm.chdate / 1000,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }